"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A Promise wrapper class allowing for resolving/rejecting the Promise outside the context of its constructor.
 *
 * @export
 * @class Deferred
 * @template TResolve The type used to resolve the promise.
 * @template TReject The type used to reject the promise. Defaults to any.
 * @link https://stackoverflow.com/a/34637436
 */
var Deferred = /** @class */ (function () {
    /**
     * Creates an instance of Deferred.
     */
    function Deferred() {
        var _this = this;
        this._promise = new Promise(function (resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "promise", {
        /**
         * Gets the Promise.
         *
         * @readonly
         * @type {Promise<TResolve>}
         */
        get: function () {
            return this._promise;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Resolves the wrapped Promise.
     *
     * @param {(TResolve | PromiseLike<TResolve>)} response The argument to be resolved by the Promise.
     * @returns {*}  {void}
     */
    Deferred.prototype.resolve = function (response) {
        if (!this._resolve) {
            return;
        }
        this._resolve(response);
    };
    /**
     *
     *
     * @param {TReject} [reason] The reason why the Promise rejected.
     * @returns {*}  {void}
     */
    Deferred.prototype.reject = function (reason) {
        if (!this._reject) {
            return;
        }
        this._reject(reason);
    };
    return Deferred;
}());
exports.Deferred = Deferred;
exports.UnregisterTimeoutInMilliseconds = 30000;
//# sourceMappingURL=Deferred.js.map